import { Microapp } from 'signup-constants/Microapp';
import { updateMicroappState } from '../store/microapp/action-creators';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { EndpointKey } from './EndpointKey';
import { logInAndQuestionsCheck } from './endpointStateChecks';
import { fetchContacts, fetchOwners, fetchStoredData, storeEmailSignature, storeOnboardingUrl } from './http-dist-030/emailSignatureApis';
import { getEmailSignatureGeneratorState } from '../store/microapp/selectors';
import { LOG } from './HttpRequester';
import { getSentryExtra } from '../error/getSentryExtra';
import { Tracker } from '../store/tracking/action-creators';
import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { redirectExistingUserAction } from '../store/auth/action-creators';
import { getPortalId } from '../store/auth/selectors';
import { getHublet } from '../store/app/selectors';
import { DefaultSignature } from '../experiments/dist-030/defaultSignature';
import { getFlatSignupDataValueMap } from '../store/signup-data/selectors';
import { getHistory } from '../routing/history';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { dist030VariantAEnrollment } from './http-dist-030/Dist030Enrollment';
const ownersExistCheck = state => {
  const emailSignatureState = getEmailSignatureGeneratorState(state);
  return Boolean(emailSignatureState.ownersExist);
};
const experimentActiveAndLoginCheck = state => {
  return dist030VariantAEnrollment() && (logInAndQuestionsCheck(state) || isExistingUserExistingAccount(state));
};
const redirectExistingUser = (dispatch, state) => {
  const portalId = getPortalId(state);
  if (isExistingUserExistingAccount(state) && portalId) {
    dispatch(redirectExistingUserAction({
      portalId,
      hublet: getHublet(state)
    }));
  }
};
const fillSignature = (dispatch, state) => {
  const signupData = getFlatSignupDataValueMap(state);
  dispatch(updateMicroappState(Microapp.EmailSignatureGenerator, {
    emailSignature: DefaultSignature(signupData)
  }));
};
const retryFetchOwners = (dispatch, state) => {
  const retries = getEndpointRetries(state, EndpointKey.FetchOwners);
  if (retries >= 5) {
    redirectExistingUser(dispatch, state);
    return;
  }
  dispatch(retryEndpoint(EndpointKey.FetchOwners, 1000));
};
export const EndpointDIST030 = {
  [EndpointKey.FetchEmailSignature]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: experimentActiveAndLoginCheck,
    method: fetchStoredData,
    handleSuccess: (response, dispatch) => {
      dispatch(updateMicroappState(Microapp.EmailSignatureGenerator, {
        emailSignature: response.data.emailSignature
      }));
    },
    handleError: (error, dispatch, getState) => {
      LOG.error('Fetching email signature error', {
        extra: getSentryExtra(error)
      });
      dispatch(Tracker.signupInteraction('dist-030-failure-to-fetch-email-signature'));
      fillSignature(dispatch, getState());
    }
  },
  [EndpointKey.CreateContact]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: experimentActiveAndLoginCheck,
    method: fetchContacts,
    handleSuccess: (response, dispatch, getState) => {
      redirectExistingUser(dispatch, getState());
      dispatch(updateMicroappState(Microapp.EmailSignatureGenerator, {
        contactVid: response.objectId
      }));
    },
    handleError: (error, dispatch, getState) => {
      const searchParams = new URLSearchParams(getHistory().location.search);
      searchParams.delete('intent');
      getHistory().replace(`${getHistory().location.pathname}?${searchParams}`);
      LOG.error('Creating contact error', {
        extra: getSentryExtra(error)
      });
      dispatch(Tracker.signupInteraction('dist-030-failure-to-create-contact'));
      redirectExistingUser(dispatch, getState());
    }
  },
  [EndpointKey.FetchOwners]: {
    isStateOnlyTrigger: true,
    once: true,
    method: fetchOwners,
    stateCheck: experimentActiveAndLoginCheck,
    handleSuccess: (response, dispatch) => {
      dispatch(updateMicroappState(Microapp.EmailSignatureGenerator, {
        ownersExist: response
      }));
    },
    handleError: (error, dispatch, getState) => {
      LOG.error('Getting owners error', {
        extra: getSentryExtra(error)
      });
      dispatch(Tracker.signupInteraction('dist-030-failure-to-get-owners'));
      retryFetchOwners(dispatch, getState());
    }
  },
  [EndpointKey.StoreEmailSignature]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state => {
      const emailSignatureState = getEmailSignatureGeneratorState(state);
      const emailSignature = emailSignatureState.emailSignature;
      return experimentActiveAndLoginCheck(state) && ownersExistCheck(state) && Boolean(emailSignature);
    },
    method: storeEmailSignature,
    handleSuccess: (response, dispatch, getState) => redirectExistingUser(dispatch, getState()),
    handleError: (error, dispatch, getState) => {
      LOG.error('Storing email signature error', {
        extra: getSentryExtra(error)
      });
      dispatch(Tracker.signupInteraction('dist-030-failure-to-store-email-signature'));
      redirectExistingUser(dispatch, getState());
    }
  },
  [EndpointKey.StoreOnboardingUrl]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: experimentActiveAndLoginCheck,
    method: storeOnboardingUrl,
    handleSuccess: (response, dispatch, getState) => redirectExistingUser(dispatch, getState()),
    handleError: (error, dispatch, getState) => {
      // Going to fallback to user-guide in app if this fails
      LOG.error('Storing onboarding url error', {
        extra: getSentryExtra(error)
      });
      dispatch(Tracker.signupInteraction('dist-030-failure-to-store-onboarding-url'));
      redirectExistingUser(dispatch, getState());
    }
  }
};